import React, { useEffect } from 'react'
import { Layout } from 'antd';
import Cookies from 'universal-cookie';
import { Route, Switch } from "react-router-dom";


// componentes
import Login from '../components/Auth/Login';
import Support from '../components/Public/Support';
import Register from '../components/Auth/Register';
import Terminos from '../components/Public/Terminos';
import ThemeEdit from '../components/ThemeEdit/index';
import Landing from "../components/Public/LandingPage";
import Productos from '../components/Public/Productos';
import ProcesadorPagos from '../components/Customer/Carrito/ProcesadorPago';
import { PublicNavbar } from '../components/Header/Header';
import Carrito from '../components/Customer/Carrito/Carrito';
import UpdatePassword from '../components/Auth/UpdatePassword';
import ProductoDetalle from '../components/Public/ProductoDetalle';
import Marketplace from '../components/Public/Cotizador/Marketplace';
import CatalogoViewer from '../components/Public/CatalogoViewer/CatalogoViewer';

import { SetCarrito } from '../Hooks/Carrito';

/**
 *
 *
 * @export
 * @function PublicRoutes
 * @extends {Component}
 */
function PublicRoutes({ setUser }) {

    const [proveedor_id, setProveedorId] = React.useState(null)
    const setCarrito = React.useContext(SetCarrito)

    useEffect(() => {
        const cookies = new Cookies()
        let carrito = cookies.get('carrito')
        if(carrito){
            setCarrito(carrito)
        }
    }, [])

    return (
        <Layout>
            <PublicNavbar proveedor={proveedor_id} />
            <Switch>
                <Route exact path="/" component={Landing} />
                <Route exact path="/login" type={2} component={Login} />
                <Route exact path="/register" type={1} component={Register} />
                <Route exact path="/productos" component={Productos} />
                <Route exact path="/terminos" component={Terminos} />
                <Route exact path="/marketplace" component={Marketplace} />

                <Route exact path="/producto/:producto_id" type={1} component={ProductoDetalle} />
                <Route exact path="/carrito-de-compra" type={1} component={Carrito} />
                <Route exact path="/carrito-de-compra-pago" type={1} component={ProcesadorPagos} />

                <Route path="/register/email-:email/token-:token" render={props => <UpdatePassword {...props} />} />
                <Route path="/recovery/email-:email/token-:token" component={UpdatePassword} />

                <Route path="/catalogo/:proveedor_url/:catalogo_url" render={props => <CatalogoViewer setProveedorId={setProveedorId} {...props} />} />
                
                <Route path="/theme" component={ThemeEdit} />
                <Route path="/soporte" component={Support} />
            </Switch>
        </Layout>

    )
}

export default PublicRoutes;
